module.exports = __webpack_public_path__ + "img/boqinspect7_7-8-2021.bce6808f.jpg";